export default __webpack_public_path__ + "static/media/tn-ventas-01.2e20d63b.jpg";